package com.essntl.features.request.data.supabase

import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.travelagent.data.supabase.TravelAgentDto
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class RequestDto(
    val id: String,
    val title: String?,
    val htmlEmail: String?,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("from_date")
    val startDate: String,
    @SerialName("to_date")
    val endDate: String,
    val areas: List<String>?,
    val extras: String?,
    @SerialName("guest_count")
    val guestCount: Int = 0,
    @SerialName("owner_id")
    val ownerId: String?,
    val clients: List<String>?,
    val status: String?,
    @SerialName("proposal_id")
    val proposalId: String?,
    @SerialName("travel_agent_data")
    val travelAgent: TravelAgentDto? = null,
    @SerialName("guest_details")
    val guestDetails: String?,
) {
    fun toModel() =
        RequestModel(
            id = id,
            createdAt = createdAt,
            title = title,
            htmlEmail = htmlEmail,
            startDate = if (startDate.length > 10) startDate.substring(0, 10) else startDate,
            endDate = if (endDate.length > 10) endDate.substring(0, 10) else endDate,
            areas = areas,
            extras = extras,
            guestCount = guestCount,
            ownerId = ownerId,
            clients = clients,
            proposalId = proposalId,
            travelAgent = travelAgent?.toModel(),
            guestDetails = guestDetails,
            status =
                when (status) {
                    "PENDING" -> RequestModel.Status.Pending
                    "ARCHIVED" -> RequestModel.Status.Archived
                    "IN_PROGRESS" -> RequestModel.Status.InProgress
                    "PROPOSAL_SENT" -> RequestModel.Status.ProposalSent
                    "BOOKED" -> RequestModel.Status.Booked
                    "NOT_BOOKED" -> RequestModel.Status.NotBooked
                    "TO_DO" -> RequestModel.Status.Todo
                    else -> null
                },
        )

    companion object {
        fun getColumns() =
            Columns.raw(
                "*, travel_agent_data:travel_agent(*)",
            )
    }
}

internal fun RequestModel.Status.toDto() =
    when (this) {
        RequestModel.Status.Pending -> "PENDING"
        RequestModel.Status.Todo -> "TO_DO"
        RequestModel.Status.Archived -> "ARCHIVED"
        RequestModel.Status.InProgress -> "IN_PROGRESS"
        RequestModel.Status.ProposalSent -> "PROPOSAL_SENT"
        RequestModel.Status.Booked -> "BOOKED"
        RequestModel.Status.NotBooked -> "NOT_BOOKED"
    }
